import { Link } from 'react-router-dom'
import { useDispatch } from "react-redux";
import { openPopup } from "../../store/popupSlice";
import Breadcrumb from '../../component/Breadcrumb';

const breadcrumbData = {
  newClass:"",
  list:[
    {
      page:"Home",
      slug:"/"
    },
    {
      page:"pharmacy App Development",
      slug:""
    },
  ]
}

export default function PharmacyBanner() {
  const dispatch = useDispatch();
  return (
    <>
      <section className="pharm-banner header-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <div className="pharm-banner-details">
                <Breadcrumb breadcrumbData={breadcrumbData}/>
                <span className='purple-gradiant'>Ai-Powered</span>
                <h1 className="heading"><small>Develop Your own</small>
                <span className='gradiant-color'> Medicine Delivery </span> App</h1>
                <p>Featuring a modern and professional interface. Streamline healthcare services, improve operational efficiency, and provide convenience to users now.</p>
                <label>21 Days Free Trial | No Credit Card Required</label>
                <Link onClick={() => dispatch(openPopup())} className='default-btn'>get started</Link>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row justify-content-between">
            <div className="col-lg-6 col-md-6 col-xxl-7">
            </div>
            <div className="col-lg-6 col-md-6 col-xxl-5">
              <div className="pharm-banner-image wow animate__animated animate__slideInRight" data-wow-delay="0.2s" data-wow-duration="1.2s">
                <img src="./assets/home/pharm-banner-img.webp" alt="banner" className="img-responsive" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
